import "../../inc/js/slick/slick.min.js";
import "../../inc/js/acf-maps.js";
import "../../inc/js/header.js";
import "../../inc/js/carousel.js";

( function( $ ) {
  
  /* Toggle nav  */  
  $(document).on('click', '.js-navModal-toggle', function() {
    var isClosing = $('body').hasClass('-navModal-open');
    
    $(this).toggleClass('-open');
    $('body').toggleClass('-navModal-open');
    $('.js-navModal').toggleClass('-collapsed');
    
    if (isClosing) {
      $('.js-navModal-mainToggle').attr('tabindex', 0).focus();
    } else {
      $('.js-navModal-mainToggle').attr('tabindex', -1);
      $('.js-navModal .js-navModal-toggle').focus();
    }
  });
  
  $(document).on('focus', '.js-focus-close-navModal', function() {
    var focusTarget = $('.js-modal-logo');
    focusTarget.focus();
  });
  
} )( jQuery );